
<style lang='scss'>
</style>

<template>
	<div>
		<Table 
		:columns="columns" 
		:data="data"
		:loading="loading"
		size="small" 
		ref="table"  
		border 
		stripe></Table>
		<compSpage
		class="text-right margin-top-10"
		v-bind="{total,pageSize:formData.rows,current:formData.page}" 
		@on-update="updateList"></compSpage>
		<Spin size="large" fix v-if="loading"></Spin>
	</div>
</template>

<script>
import compSpage from '@/components/boss/spage';
import { HttpWhAccountLog } from '@/service/boss/allot';
export default {
	props: ['id'],
	components: {
		compSpage,
	},
	data() {
		return {
			data: [],
			loading: false,
			total: 0,
			formData: {
				page: 1,
				rows: 10,
				sidx: 'id',
				sord: 'desc',
				search: {
					EQ_systemId: this.id
				}
			},
		};
	},
	created() {
		this.updateList();
	},
	methods: {
		async updateList(data = {}) {
			this.loading = true;
			this.formData = Object.assign({}, this.formData, data);
			const response = await HttpWhAccountLog(this.formData).catch(res => {
				this.loading = false;
				this.$Message.error(res.message);
			});
			if (response) {
				const data = response.data;
				this.loading = false;
				this.data = data.content || [];
				this.total = data.totalElements || 0;
			}
		},
	},
	computed: {
		columns() {
			return [
				{
					title: this.$t('global.common.operator', { defaultValue: '操作人' }),
					key: 'opUserName',
				},

				{
					title: this.$t('erp.channel.operation_content', { defaultValue: '操作内容' }),
					key: 'opRemark',
					maxWidth: 300,
					// render(h, { row }) {
					// 	return <span>{row.opModel} {row.opData}</span>
					// }
				},
				{
					title: this.$t('global.common.operate_time', { defaultValue: '操作时间' }),
					key: 'opAt',
				},
			];
		},
	},
};
</script>



